import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Plus, Edit, Trash2, Search } from 'lucide-react';
import { toast } from 'sonner';

const Shifts = () => {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({ name: '', start_time: '', end_time: '' });

  useEffect(() => { fetchShifts(); }, []);
  const fetchShifts = async () => { try { const r = await api.get('/sales/shifts'); setShifts(r.data); } catch(e){} finally { setLoading(false); } };

  const openCreate = () => { setEditing(null); setFormData({ name: '', start_time: '', end_time: '' }); setShowModal(true); };
  const openEdit = (s) => { setEditing(s); setFormData({ name: s.name, start_time: s.start_time, end_time: s.end_time }); setShowModal(true); };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) await api.put(`/sales/shifts/${editing.id}`, formData);
      else await api.post('/sales/shifts', formData);
      setShowModal(false); fetchShifts();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  const deleteShift = async (id, name) => {
    if (!window.confirm(`Delete shift "${name}"?`)) return;
    try { await api.delete(`/sales/shifts/${id}`); fetchShifts(); } catch(e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  const filtered = shifts.filter(s => s.name.toLowerCase().includes(searchTerm.toLowerCase()) || s.shift_code.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div data-testid="shifts-page">
      <div className="flex items-center justify-between mb-4">
        <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Shift Master</h1>
        <button onClick={openCreate} className="btn btn-primary" data-testid="add-shift-btn"><Plus size={16} /> Add Shift</button>
      </div>
      <div className="card mb-4">
        <div className="form-group" style={{ marginBottom: 0 }}>
          <div style={{ position: 'relative' }}>
            <Search size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
            <input type="text" className="form-input" placeholder="Search shifts..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ paddingLeft: '40px' }} data-testid="search-input" />
          </div>
        </div>
      </div>
      <div className="card">
        {loading ? <div>Loading...</div> : (
          <div className="table-container">
            <table>
              <thead><tr><th>Code</th><th>Name</th><th>Start</th><th>End</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.map(s => (
                  <tr key={s.id} data-testid={`shift-row-${s.shift_code}`}>
                    <td className="font-mono">{s.shift_code}</td>
                    <td>{s.name}</td>
                    <td>{s.start_time}</td>
                    <td>{s.end_time}</td>
                    <td><span className={`badge ${s.status === 'active' ? 'badge-success' : 'badge-danger'}`}>{s.status}</span></td>
                    <td>
                      <div className="flex gap-2">
                        <button onClick={() => openEdit(s)} className="btn btn-ghost btn-sm" data-testid={`edit-btn-${s.shift_code}`}><Edit size={14} /></button>
                        <button onClick={() => deleteShift(s.id, s.name)} className="btn btn-ghost btn-sm" data-testid={`delete-btn-${s.shift_code}`}><Trash2 size={14} color="#DC2626" /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {showModal && (
        <div className="modal-overlay" data-testid="shift-modal">
          <div className="modal-content" style={{ maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <div className="modal-header"><h2 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>{editing ? 'Edit Shift' : 'Add Shift'}</h2></div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Name *</label><input type="text" className="form-input" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} required data-testid="name-input" /></div>
                <div className="grid grid-cols-2">
                  <div className="form-group"><label className="form-label">Start Time *</label><input type="time" className="form-input" value={formData.start_time} onChange={(e) => setFormData({...formData, start_time: e.target.value})} required data-testid="start-input" /></div>
                  <div className="form-group"><label className="form-label">End Time *</label><input type="time" className="form-input" value={formData.end_time} onChange={(e) => setFormData({...formData, end_time: e.target.value})} required data-testid="end-input" /></div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" onClick={() => setShowModal(false)} className="btn btn-secondary">Cancel</button>
                <button type="submit" className="btn btn-primary" data-testid="submit-shift-btn">{editing ? 'Update' : 'Add Shift'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Shifts;
